/**
 * Preserve all the API URLs here, and uncomment as needed for development
 * api should be set to the following before committing changes:
 *      process.env.REACT_APP_API_URL || "http://localhost:8080";
 */

export const api = process.env.REACT_APP_API_URL || 'http://localhost:8000/v1/'
console.log('API:', api)

/**
 * Base URL of the v2 endpoints (case images, case image variants). The
 * configured URL names the v1 root, so the version segment is swapped here
 * once instead of in every v2 client module.
 */
export const v2Api = api.replace(/v1\/?$/, 'v2/')

export default api
